export const Social = {
    Providers: {
        FACEBOOK: "Facebook",
        LINKEDIN: "LinkedIn",
        MICROSOFT: "Microsoft"
    }
};
